@import '../../styles/mixins/_btalk-mixins.scss';
@import '../../styles/variables/_btalk-variables.scss';
@import '../../styles/classes.scss';
@import '../../styles/header-nav.scss';
@import '../../styles/buttons.scss';

:host {
  display: block;
  border-bottom: 0;
  box-shadow: 0;
}

.btalk-nav-wrap.mobile {

  .btalk-nav li{
    margin: 0 auto;
    width: $site-width;
    max-width: $site-max-width;
  }
  .btalk-navbar {
    border-bottom: 0;
  }
  ul#menu-header-foot {
    background: #F9F9F9;
  }
  li.menu-item.btl-out.btl-join.btalk-join{
    padding: 10px;
    border-bottom: 0;
  }
  li.menu-item.btl-out.btl-join.btalk-join a{
    background-color: #270;
    border-radius: 3px;
    color: #fff;
    display: block;
    width: 100%;
    text-align: center;
  }
}
